import { Helmet } from "react-helmet";
import DigitalServicesLayout from "../../sections/services/digital/digitalServicesLayout";

const DigitalServicesPage = () => {
    return (
        <>
            <Helmet>
                <title>code3x Digital Solutions | Smart Tools for Business Growth</title>
                <meta name="description" content="Explore Code3x’s digital solutions designed to empower businesses with smart, scalable tools." />
                <meta name="keywords" content="code3x digital solutions, digital services, web apps, mobile apps, enterprise solutions, cloud solutions, digital transformation, leading digitals service provider, Sri Lanka" />
                <link rel="canonical" href="https://code3x.tech/suite/digital" />
            </Helmet>

            <DigitalServicesLayout />
        </>
    );
}

export default DigitalServicesPage;